var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 26,
    height: 24,
    transform: "translate(-719 2629)",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_84",
    "data-name": "Mask Group 84",
    transform: "translate(719 -2629)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bin_1_",
    "data-name": "bin(1)",
    transform: "translate(-714.765 2629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M86.967,60.142a.541.541,0,0,0-.514.565V71.391a.516.516,0,1,0,1.028,0V60.707A.541.541,0,0,0,86.967,60.142Zm0,0",
    transform: "translate(-75.016 -51.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M41.094,60.142a.541.541,0,0,0-.514.565V71.391a.516.516,0,1,0,1.028,0V60.707A.541.541,0,0,0,41.094,60.142Zm0,0",
    transform: "translate(-35.208 -51.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M1.444,7.185V21.11A3.3,3.3,0,0,0,2.2,23.261a2.429,2.429,0,0,0,1.836.873h9.723a2.428,2.428,0,0,0,1.836-.873,3.3,3.3,0,0,0,.754-2.151V7.185A2.163,2.163,0,0,0,17.79,4.819a2.037,2.037,0,0,0-1.947-1.88h-2.63V2.232A2.338,2.338,0,0,0,12.619.649,1.929,1.929,0,0,0,11.177,0H6.614A1.929,1.929,0,0,0,5.172.649a2.338,2.338,0,0,0-.593,1.584v.705H1.948A2.037,2.037,0,0,0,0,4.819,2.163,2.163,0,0,0,1.444,7.185ZM13.757,23H4.034A1.73,1.73,0,0,1,2.472,21.11V7.235H15.319V21.11A1.73,1.73,0,0,1,13.757,23ZM5.606,2.232A1.146,1.146,0,0,1,5.9,1.447a.945.945,0,0,1,.714-.317h4.564a.945.945,0,0,1,.714.317,1.146,1.146,0,0,1,.292.785v.707H5.606ZM1.947,4.069h13.9a.974.974,0,0,1,.925,1.017A.974.974,0,0,1,15.843,6.1H1.947a.974.974,0,0,1-.924-1.018A.974.974,0,0,1,1.947,4.069Zm0,0",
    transform: "translate(0.023 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M64.026,60.142a.541.541,0,0,0-.514.565V71.391a.516.516,0,1,0,1.028,0V60.707A.541.541,0,0,0,64.026,60.142Zm0,0",
    transform: "translate(-55.109 -51.398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d5253c5dbf9044706d7ecb4207634064.svg";
export { ForwardRef as ReactComponent };